import { Box, Stack, Typography } from '@mui/material';
import type { UserAssertion } from '@/types';
import JudgementOutcomeLine from '@/components/review/JudgementOutcomeLine';

interface Props {
  assertions: UserAssertion[];
}

export default function OfficialAnswersGrid({ assertions }: Props) {
  if (!assertions.length) return null;

  const colCount = assertions.length;

  return (
    <Stack spacing={1.25}>
      <Stack direction="row" spacing={2} alignItems="baseline" flexWrap="wrap" useFlexGap>
        <Typography
          variant="caption"
          color="text.secondary"
          fontWeight={700}
          sx={{ minWidth: 52, letterSpacing: '0.04em' }}
        >
          判決評價
        </Typography>
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            display: 'grid',
            gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))`,
            gap: 2,
            alignItems: 'start',
          }}
        >
          {assertions.map((assertion) => (
            <Box key={assertion.assertion_id} sx={{ minWidth: 0 }}>
              <JudgementOutcomeLine
                variant="body2"
                judgement={assertion.judgement}
                reviewedDecision={assertion.reviewedBall}
                reviewedPunishment={assertion.reviewedSanction}
                sx={{ color: 'text.primary', fontSize: '1rem', lineHeight: 1.5, fontWeight: 500 }}
              />
            </Box>
          ))}
        </Box>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="flex-start" flexWrap="wrap" useFlexGap>
        <Typography
          variant="caption"
          color="text.secondary"
          fontWeight={700}
          sx={{ minWidth: 52, pt: 0.15, letterSpacing: '0.04em' }}
        >
          備註
        </Typography>
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            display: 'grid',
            gridTemplateColumns: `repeat(${colCount}, minmax(0, 1fr))`,
            gap: 2,
            alignItems: 'start',
          }}
        >
          {assertions.map((assertion) => (
            <Typography
              key={`${assertion.assertion_id}-note`}
              variant="body1"
              sx={{
                minWidth: 0,
                whiteSpace: 'pre-wrap',
                lineHeight: 1.55,
                color: 'text.primary',
              }}
            >
              {assertion.notes?.trim() || '—'}
            </Typography>
          ))}
        </Box>
      </Stack>
    </Stack>
  );
}
